import React, { HTMLAttributes } from 'react';
import c from 'classnames';
import s from './InputHint.scss';

interface Props extends HTMLAttributes<HTMLSpanElement> {
  className?: string;
}

/** Some muted text that's meant to be included after an input field. */
const InputHint: React.FC<Props> = ({ children, className, ...rest }) => {
  return (
    <span className={c(s['root'], className)} {...rest}>
      {children}
    </span>
  );
};
InputHint.displayName = 'InputHint';

export default InputHint;
